<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/zhaoshang/customer' }">客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>客户项目续签</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">客户项目续签</span>
      </div>

      <el-form :model="form" ref="formRef" :rules="formRules" label-width="120px" :inline="false" size="normal">

        <el-row :gutter="20">
          <el-col :span="8" :offset="0">
             <!-- 客户信息 -->
            <el-form-item label="客户名称：" prop="customerId">
              <el-input disabled v-model="form.customerName" placeholder="请输入客户名称" style="width: 100%"></el-input>
            </el-form-item>

            <!-- 项目信息 -->
            <el-form-item label="成交项目：" prop="projectId">
              <el-input disabled v-model="form.projectName" placeholder="请输入项目名称" style="width: 100%"></el-input>
            </el-form-item>

            <!-- 收款日期 -->
            <el-form-item label="签约时间：" prop="dealDate">
              <el-date-picker
                v-model="form.dealDate"
                type="date"
                placeholder="请选择签约时间"
                style="width: 100%"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

            <!-- 合同金额 -->
            <el-form-item label="合同金额：" prop="contractAmount">
              <el-input-number v-model="form.contractAmount" :min="0" :step="100" placeholder="请输入金额"
                style="width: 200px"></el-input-number>
            </el-form-item>

            <!-- 抽佣比例 -->
            <el-form-item label="抽佣比例：" prop="commissionRate">
              <el-input-number v-model="form.commissionRate" :min="0" :max="100" :precision="1" :step="0.5" placeholder="请输入抽佣比例" style="width: 200px"></el-input-number>
              <span style="margin-left: 10px; color: #909399;">%</span>
            </el-form-item>

            <!-- 合同期限 -->
            <el-form-item label="合同期限：" prop="serviceDateRange">
              <div style="display: flex; align-items: center;">
                <el-date-picker
                  v-model="form.serviceStartDate"
                  type="date"
                  placeholder="开始日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%">
                </el-date-picker>
                <span style="margin: 0 10px;">至</span>
                <el-date-picker
                  v-model="form.serviceEndDate"
                  type="date"
                  placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%">
                </el-date-picker>
              </div>
            </el-form-item>

            <!-- 合同备注 -->
            <el-form-item label="合同备注：" prop="contractRemark">
              <el-input v-model="form.contractRemark" type="textarea" :rows="6" placeholder="合同的备忘、补充或其他约定。如：0元二店合同。再比如：合同签订日期延迟一个月。" maxlength="500"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" :loading="submitting" @click="okClickHandler">立即创建</el-button>
              <el-button @click="goBack">返回</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="0">
            <!-- 收支类型 -->
            <el-form-item label="收支类型：" prop="type">
              <el-radio-group v-model="form.type">
                <el-radio :label="1">收款</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 总金额 -->
            <el-form-item label="收款金额：" prop="totalAmount">
              <el-input-number v-model="form.totalAmount" :min="0" :step="100" placeholder="请输入金额" style="width: 200px"></el-input-number>
            </el-form-item>

            <!-- 收款账户 -->
            <el-form-item label="收款账户：" prop="payAccount">
              <el-select v-model="form.payAccount" placeholder="请选择收款账户" style="width: 100%">
                <el-option v-for="item in payAccountList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>

            <!-- 钱款类型 -->
            <el-form-item label="钱款类型:" prop="payType">
              <el-radio-group v-model="form.payType" size="small">
                <el-radio-button v-for="item in payTypeList" :key="item" :label="item">{{ item }}</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <!-- 收款日期 -->
            <el-form-item label="收款日期：" prop="payDate">
              <el-date-picker
                v-model="form.payDate"
                type="date"
                placeholder="请选择收款日期"
                style="width: 100%"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

            <!-- 收款备注 -->
            <el-form-item label="收款备注：" prop="remark">
              <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注信息（选填，最多500字符）" maxlength="500"></el-input>
            </el-form-item>

            <!-- 附件上传 -->
            <el-form-item label="附件：">
            <el-upload
              :action="uploadUrl"
              :headers="uploadHeaders"
              :on-success="handleUploadSuccess"
              :on-remove="handleRemove"
              :on-preview="handlePreview"
              :before-upload="beforeUpload"
              :file-list="fileList"
              list-type="picture-card">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">支持图片、PDF等文件格式</div>
            </el-upload>
          </el-form-item>

          </el-col>
        </el-row>

      </el-form>

    </el-card>

    <!-- PDF预览对话框 -->
    <el-dialog :visible.sync="pdfPreviewDialogVisible" width="60%" :title="previewTitle">
      <div class="preview-container" style="height: 600px;">
        <iframe :src="previewUrl" style="width: 100%; height: 100%; border: none;"></iframe>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <el-image
      v-show="false"
      ref="imageViewer"
      :src="currentImageUrl"
      :preview-src-list="imagePreviewList">
    </el-image>

  </div>
</template>

<script>
import { payAccountList } from '@/utility/staticData'
export default {
  data () {
    return {
      // 提交中标志位（防重复点击）
      submitting: false,

      form: {
        projectId: '',
        projectName: '',
        customerName: '',
        type: 1,
        payType: '续签款',
        payAccount: '',
        totalAmount: 0,
        payDate: '',
        attachments: [],
        remark: '',

        dealDate: '', // 签约时间
        contractAmount: 0, // 合同金额
        commissionRate: 0, // 抽佣比例
        serviceStartDate: '', // 服务开始时间
        serviceEndDate: '', // 服务结束时间
        serviceDateRange: '', // 合同期限（用于校验）
        contractRemark: '' // 合同备注
      },

      formRules: {
        dealDate: [
          { required: true, message: '请选择签约时间', trigger: 'change' }
        ],
        payAccount: { required: true, message: '请选择收款账户', trigger: 'change' },
        totalAmount: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { type: 'number', min: 0, message: '金额不能为负数', trigger: 'blur' }
        ],
        payDate: { required: true, message: '请选择收款日期', trigger: 'change' },
        remark: { type: 'string', max: 500, message: '备注信息不能超过500个字符', trigger: 'blur' },
        contractAmount: [
          { required: true, message: '请输入合同金额', trigger: 'blur' },
          { type: 'number', min: 0, message: '合同金额不能为负数', trigger: 'blur' }
        ],
        commissionRate: [
          { required: true, message: '请输入抽佣比例', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '抽佣比例范围为0-100', trigger: 'blur' }
        ],
        serviceDateRange: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.form.serviceStartDate) {
                callback(new Error('请选择合同开始日期'))
              } else if (!this.form.serviceEndDate) {
                callback(new Error('请选择合同结束日期'))
              } else if (new Date(this.form.serviceStartDate) > new Date(this.form.serviceEndDate)) {
                callback(new Error('合同结束日期不能早于开始日期'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },

      // 列表数据
      payTypeList: ['续签款'],
      payAccountList: payAccountList,

      // 当前账号信息
      accountInfo: {
        level: null,
        employeeId: '',
        employeeName: '',
        department: '',
        job: ''
      },

      // 上传使用
      uploadUrl: this.$http.defaults.baseURL + 'upload',
      uploadHeaders: {
        authorization: window.sessionStorage.getItem('token'),
        Accept: 'application/json'
      },
      fileList: [],

      // 预览相关
      pdfPreviewDialogVisible: false,
      previewUrl: '',
      previewTitle: '',
      currentImageUrl: '',
      imagePreviewList: [],

      // PDF 图标路径
      pdfIconUrl: require('@/assets/pdf.png'),

      // 用于预览的基础url
      base: ''
    }
  },
  created () {
    this.base = window.sessionStorage.getItem('base')
    this.getAccountInfo()
  },
  methods: {
    // 获取当前登录账号的信息
    getAccountInfo () {
      this.accountInfo.level = parseInt(window.sessionStorage.getItem('level'))
      this.accountInfo.employeeId = window.sessionStorage.getItem('employeeId') || ''
      this.accountInfo.employeeName = window.sessionStorage.getItem('employeeName') || ''
      this.accountInfo.department = window.sessionStorage.getItem('department') || ''
      this.accountInfo.job = window.sessionStorage.getItem('job') || ''

      // 从路由参数获取客户信息
      const customerName = decodeURIComponent(this.$route.query.customerName)
      const projectId = this.$route.query.projectId
      const projectName = decodeURIComponent(this.$route.query.projectName)

      this.form.customerName = customerName
      this.form.projectId = projectId
      this.form.projectName = projectName
    },

    // 判断文件类型
    getFileType (fileName) {
      const ext = fileName.toLowerCase().split('.').pop()
      const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      const pdfExts = ['pdf']

      if (imageExts.includes(ext)) return 'image'
      if (pdfExts.includes(ext)) return 'pdf'
      return 'other'
    },

    // 上传前校验
    beforeUpload (file) {
      const fileType = this.getFileType(file.name)
      const isValidType = ['image', 'pdf'].includes(fileType)

      if (!isValidType) {
        this.$message.error('只支持上传图片或PDF文件')
        return false
      }

      const isLt50M = file.size / 1024 / 1024 < 50
      if (!isLt50M) {
        this.$message.error('文件大小不能超过 50MB!')
        return false
      }

      return true
    },

    // 上传成功
    handleUploadSuccess (res, file, fileList) {
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }

      const fileType = this.getFileType(file.name)
      const baseUrl = this.base

      // 为PDF文件设置自定义图标
      if (fileType === 'pdf') {
        const fileItem = fileList[fileList.length - 1]
        fileItem.url = this.pdfIconUrl // 用于显示图标
        fileItem.actualUrl = baseUrl + res.data.url // 保存实际文件地址用于预览
      }

      this.form.attachments.push({
        url: res.data.url,
        name: file.name,
        type: fileType
      })
      this.fileList = fileList
    },

    // 删除文件
    handleRemove (file, fileList) {
      const index = this.fileList.indexOf(file)
      if (index !== -1 && this.form.attachments[index]) {
        this.form.attachments.splice(index, 1)
      }
      this.fileList = fileList
    },

    // 预览文件
    handlePreview (file) {
      const attachment = this.form.attachments.find(item => item.name === file.name)
      if (!attachment) return

      const baseUrl = this.base
      const fileUrl = baseUrl + attachment.url

      console.log(fileUrl)

      this.previewTitle = file.name

      if (attachment.type === 'image') {
        // 使用 Element UI 的图片预览
        this.buildImagePreviewList()
        this.currentImageUrl = fileUrl
        this.$nextTick(() => {
          this.$refs.imageViewer.clickHandler()
        })
      } else if (attachment.type === 'pdf') {
        // PDF使用对话框预览
        this.previewUrl = file.actualUrl || fileUrl
        this.pdfPreviewDialogVisible = true
      }
    },

    // 构建图片预览列表
    buildImagePreviewList () {
      const baseUrl = this.base
      this.imagePreviewList = this.form.attachments
        .filter(item => item.type === 'image')
        .map(item => baseUrl + item.url)
    },

    // 点击添加按钮
    async okClickHandler () {
      // 防止重复点击：提交中直接拦截
      if (this.submitting) return

      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return false

        const submitData = {
          projectId: this.form.projectId || null,

          dealDate: this.form.dealDate || null,
          contractAmount: this.form.contractAmount,
          commissionRate: this.form.commissionRate,
          serviceStartDate: this.form.serviceStartDate,
          serviceEndDate: this.form.serviceEndDate,
          contractRemark: this.form.contractRemark || '',

          payAccount: this.form.payAccount,
          totalAmount: this.form.totalAmount,
          payDate: this.form.payDate,
          attachments: this.form.attachments,
          remark: this.form.remark || ''
        }

        // 进入提交中状态
        this.submitting = true
        try {
          const { data: res } = await this.$http.post('zhaoshang/contract/add', submitData)
          if (res.meta.status !== 200) {
            this.$message.error(res.meta.msg)
            return false
          }
          this.$message.success(res.meta.msg)
          this.goBack()
        } catch (error) {
          console.error('添加财务记录失败:', error)
          this.$message.error('添加财务记录失败')
        } finally {
          // 无论成功失败，释放提交状态
          this.submitting = false
        }
      })
    },

    // 返回
    goBack () {
      const query = { ...this.$route.query }
      delete query.customerId
      delete query.customerName
      delete query.projectId
      delete query.projectName

      // 构建返回URL
      const queryString = Object.keys(query).length > 0
        ? '?' + Object.entries(query).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')
        : ''

      this.$router.push('/zhaoshang/customer' + queryString)
    }
  }
}
</script>

<style lang="less" scoped>
.preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

// 自定义上传列表中的PDF图标样式
::v-deep .el-upload-list__item-thumbnail {
  object-fit: contain;
}

// 图片预览样式优化
::v-deep .el-image-viewer__wrapper {
  z-index: 3000;
}
</style>
